import { useState, useEffect } from "react";
import { navLinks, contactInfo } from "@/mocks/homeData";

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-20">
          <a
            href="#accueil"
            onClick={(e) => {
              e.preventDefault();
              handleNavClick("#accueil");
            }}
            className="flex items-center shrink-0"
          >
            <img
              src="/assets/images/favicon.webp"
              alt="Mobicar Pro Garage"
              width="512"
              height="512"
              className="h-10 md:h-12 w-auto rounded-md"
            />
          </a>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick(link.href);
                }}
                className={`px-3 py-2 text-sm font-medium rounded-md transition-colors whitespace-nowrap ${
                  scrolled
                    ? "text-foreground-800 hover:text-primary-500"
                    : "text-white/90 hover:text-white"
                }`}
              >
                {link.label}
              </a>
            ))}
          </div>

          <a
            href={contactInfo.phoneHref}
            className="hidden md:inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-white text-sm font-semibold rounded-md transition-colors whitespace-nowrap"
          >
            <i className="ri-phone-line w-4 h-4 flex items-center justify-center" />
            Appeler le garage
          </a>

          <button
            type="button"
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden p-2 ${
              scrolled ? "text-foreground-900" : "text-white"
            }`}
            aria-label="Ouvrir le menu"
          >
            <i
              className={`${
                mobileOpen ? "ri-close-line" : "ri-menu-line"
              } w-6 h-6 flex items-center justify-center text-xl`}
            />
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50/95 backdrop-blur-md border-t border-background-200 shadow-lg">
          <div className="px-4 py-4 space-y-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick(link.href);
                }}
                className="block px-3 py-2.5 text-sm font-medium rounded-md text-foreground-800 hover:text-primary-500 hover:bg-background-100 transition-colors"
              >
                {link.label}
              </a>
            ))}
            <a
              href={contactInfo.phoneHref}
              className="flex items-center gap-2 px-3 py-2.5 mt-2 text-sm font-semibold rounded-md bg-primary-500 text-white hover:bg-primary-600 transition-colors"
            >
              <i className="ri-phone-line w-4 h-4 flex items-center justify-center" />
              Appeler le garage
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}